<template>
  <div class="topActionBar">
    <div style="display: flex;" v-if="!$store.state.conversation.activeConversation.isGroupConversation && !$store.state.conversation.activeConversation.isChannelConversation" @click="showContactInfo">
      <img v-if="$store.state.conversation.activeConversation.Contact.PhotoURL == '/images/nophoto.png' || !$store.state.conversation.activeConversation.Contact.PhotoURL" src="@/assets/images/nophoto.png" class="avatarImageTopBar" />
      <img v-else :src="imageData" class="avatarImageTopBar" />
      <div>
        <div class="userName">
          {{ $store.state.conversation.activeConversation.Contact.VisibleName }}
        </div>
        <div class="userInfo" v-if="$store.state.conversation.activeConversation.isBuddyWriting === false">
          Kullanıcı bilgisi için dokunun
        </div>
        <div class="userWriting" v-if="$store.state.conversation.activeConversation.isBuddyWriting === true">
          Yazıyor...
        </div>
      </div>
    </div>
    <div style="display: flex;" v-else @click="showGroupInfo">
      <img v-if="!$store.state.conversation.activeConversation.PhotoURL" src="@/assets/images/groupdefault.png" class="avatarImageTopBar" />
      <img v-else :src="imageData" class="avatarImageTopBar" />
      <div>
        <div class="userName">
          {{ $store.state.conversation.activeConversation.isChannelConversation ? $store.state.conversation.activeConversation.ChannelName : $store.state.conversation.activeConversation.GroupName }}
        </div>
        <div class="userInfo" v-if="!showChannelWriting">
          {{ $store.state.conversation.activeConversation.isChannelConversation ? 'Kanal bilgisi için dokunun' : 'Grup bilgisi için dokunun' }}
        </div>
        <div class="userWriting" v-else>{{ $store.state.conversation.activeConversation.writingParticipant }} yazıyor...</div>
      </div>
    </div>
    <TakePhoto />
    <div class="spacer" />
    <a class="searchBtn" style="display: none;">
      <img src="@/assets/images/search.png" alt="" />
    </a>

    <input style="display: none;" ref="imageFileSelector" @input="imageFilesSelected" type="file" accept="image/*" multiple />

    <input style="display: none;" ref="documentFileSelector" @input="documentFilesSelected" type="file" accept="*" />

    <circle-menu v-if="isChatAttachmentUploadEnabled" ref="circleMenu" type="bottom" :number="3" style="margin-right:10px; z-index: 999;" :colors="['#EAECEB', '#e53935', '#1E88E5', '#43A047', '#FB8C00']">
      <a class="attachBtn" slot="item_btn" v-if="!isUploaderOpen">
        <img src="@/assets/images/attachment.png" alt="" />
      </a>
      <div slot="item_1" v-if="isChatAttachmentUploadEnabled">
        <a class="menubtn" @click="openFileDialog">
          <img class="circleMenuImage" src="@/assets/images/menu-sendmedia.png" />
        </a>
      </div>

 

      <div slot="item_2" v-if="isChatAttachmentUploadEnabled">
        <a class="menubtn" @click="openFileDialogDocument">
          <img class="circleMenuImage" src="@/assets/images/menu-sendfile.png" />
        </a>
      </div>

      <div slot="item_3">
        <a class="menubtn">
          <img class="circleMenuImage" src="@/assets/images/menu-sendcard.png" />
        </a>
      </div>
    </circle-menu>

    <dropdown :is-icon="false" :class-name="'topBar'" :close-on-click="true" ref="photoDropDown">
      <template slot="btn">
        <a class="menuBtn">
          <img src="@/assets/images/menu.png" />
        </a>
      </template>
      <template slot="body">
        <div class="photoMenuItem" @click="ClearOrRemoveChat(false)">
          Sohbeti Temizle
        </div>
        <div class="photoMenuItem" @click="ClearOrRemoveChat(true)">
          Sohbeti Sil
        </div>
        <div class="photoMenuItem" @click="togglePinConversation(!$store.state.conversation.activeConversation.isPinned)">
          <span v-if="$store.state.conversation.activeConversation.isPinned == undefined || $store.state.conversation.activeConversation.isPinned == false">Sohbeti Sabitle</span>
          <span v-if="$store.state.conversation.activeConversation.isPinned == true">Sabitlemeyi Kaldır</span>
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import { socketOutputMixin } from '@/mixins/socketOutputMixin.js'
import EventBus from '@/eventbus.js'
var moment = require('moment')
export default {
  data() {
    return {
      colors: ['rgb(255, 255, 102)', 'rgb(255, 255, 102)', '#FFE26F', '#F3825F', '#F19584'],
      imageData: null
    }
  },
  mixins: [messageMixin, socketOutputMixin],
  computed: {
    isChatAttachmentUploadEnabled() {
      return process.env.VUE_APP_CHAT_ATTACHMENT_UPLOAD_ENABLED !== 'false'
    },
    isUploaderOpen() {
      let uploaders = this.$store.state.conversation.activeConversation.uploaders
      return uploaders.documentUploader.isVisible || uploaders.imageUploader.isVisible
    },
    activeConversation() {
      return this.$store.state.conversation.activeConversation
    },
    showChannelWriting() {
      return !this.activeConversation.isChannelConversation && this.activeConversation.writingParticipant
    }
  },
  watch: {
    activeConversation: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== undefined && newValue.Contact !== undefined && newValue.Contact.PhotoURL !== undefined) {
          this.image(newValue.Contact.PhotoURL).then(value => {
            this.imageData = value
          })
        } else if (newValue !== undefined) {
          this.image(newValue.PhotoURL).then(value => {
            this.imageData = value
          })
        }
      }
    }
  },
  methods: {
    takePhoto() {
      this.$refs.photoDropDown.isHidden = true
      this.$modal.show('cameraModal')
      EventBus.$emit('takePhoto')
    },
    image(url) {
      var vm = this
      return new Promise(function(resolve, reject) {
        if (url === null) {
          resolve(null)
        }
        if (url.includes('http')) {
          resolve(vm.makeBlob(url, url))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key
            .split('')
            .reverse()
            .join('')
          let encryptedBody = vm.ewk(url, key, iv)
          resolve(vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url))
        }
      })
    },
    imageGroup(url) {
      var vm = this
      return new Promise(function(resolve, reject) {
        if (vm.$store.state.conversation.activeConversation.Contact === undefined) {
          resolve('')
        }
        if (url.includes('http')) {
          resolve(vm.makeBlob(url, url))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key
            .split('')
            .reverse()
            .join('')
          let encryptedBody = vm.ewk(url, key, iv)
          resolve(vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url))
        }
      })
    },

    togglePinConversation(pinStatus) {
      let convID = this.$store.state.conversation.activeConversation.ConversationID
      let isGroup = this.$store.state.conversation.activeConversation.GroupID != undefined
      let isChannel = this.$store.state.conversation.activeConversation.ChannelID != undefined
      if (isGroup) {
        this.$set(this.$store.state.group.groups.find(x => x.GroupID == convID), 'isPinned', undefined)
        this.$set(this.$store.state.group.groups.find(x => x.GroupID == convID), 'pinCreateDate', undefined)
      } else if (isChannel) {
        this.$set(this.$store.state.channel.channels.find(x => x.ChannelID == convID), 'isPinned', undefined)
        this.$set(this.$store.state.channel.channels.find(x => x.ChannelID == convID), 'pinCreateDate', undefined)
      } else {
        this.$set(this.$store.state.conversation.conversations.find(x => x.ConversationID == convID), 'isPinned', undefined)
        this.$set(this.$store.state.conversation.conversations.find(x => x.ConversationID == convID), 'pinCreateDate', undefined)
      }
      if (pinStatus == true) {
        this.$set(this.$store.state.conversation.activeConversation, 'isPinned', true)
      } else {
        this.$set(this.$store.state.conversation.activeConversation, 'isPinned', undefined)
      }

      var vm = this

      if (pinStatus === true) {
        var pin = {
          isGroup: this.$store.state.conversation.activeConversation.GroupID != undefined || this.$store.state.conversation.activeConversation.ChannelID != undefined,
          CreateDate: moment().toISOString(),
          UniqueID: this.$store.state.conversation.activeConversation.ConversationID == undefined ? (this.$store.state.conversation.activeConversation.GroupID || this.$store.state.conversation.activeConversation.ChannelID) : this.$store.state.conversation.activeConversation.ConversationID
        }
        if (this.$store.state.conversation.userSettings === undefined) {
          this.$store.state.conversation.userSettings = {
            Pins: []
          }
        }
        this.$store.state.conversation.userSettings.Pins.push(pin)
      } else {
        let index = this.$store.state.conversation.userSettings.Pins.map(function(e) {
          return e.UniqueID
        }).indexOf(this.$store.state.conversation.activeConversation.ConversationID)
        if (index == -1) {
          index = this.$store.state.conversation.userSettings.Pins.map(function(e) {
            return e.UniqueID
          }).indexOf(this.$store.state.conversation.activeConversation.ConversationID)
        }
        if (index != -1) {
          this.$store.state.conversation.userSettings.Pins.splice(index, 1)
        }
      }
      // console.log(this.$store.state.conversation.userSettings.Pins)
      this.setPinConversation()
      setTimeout(function() {
        vm.get_settings()
      }, 500)
    },
    ClearOrRemoveChat(isRemove) {
      this.clearOrRemoveChat(this.$store.state.conversation.activeConversation, isRemove)
    },
    openFileDialog() {
      if (!this.isChatAttachmentUploadEnabled) {
        return
      }
      this.$refs.imageFileSelector.click()
      this.$refs.circleMenu.toggle()
    },

    openFileDialogDocument() {
      if (!this.isChatAttachmentUploadEnabled) {
        return
      }
      this.$refs.documentFileSelector.click()
      this.$refs.circleMenu.toggle()
    },

    imageFilesSelected() {
      if (!this.isChatAttachmentUploadEnabled) {
        this.$refs.imageFileSelector.value = ''
        return
      }
      var inputFiles = []

      for (let file of this.$refs.imageFileSelector.files) {
        let mod = JSON.parse(JSON.stringify(this.$store.state.message.uploadFileModel))
        mod.file = file
        mod.processId = this.$uuid.v4()
        mod.uploadUrl = process.env.VUE_APP_UPLOADURL
        inputFiles.push(mod)
      }

      this.$store.commit('setActiveConversationImageUploaderFiles', inputFiles)
      this.$store.commit('setActiveConversationImageUploaderVisibility', true)
      this.$refs.imageFileSelector.value = ''
    },

    documentFilesSelected() {
      if (!this.isChatAttachmentUploadEnabled) {
        this.$refs.documentFileSelector.value = ''
        return
      }
      var inputFiles = []

      for (let file of this.$refs.documentFileSelector.files) {
        let mod = JSON.parse(JSON.stringify(this.$store.state.message.uploadFileModel))
        mod.file = file
        mod.originalFileName = file.name
        mod.processId = this.$uuid.v4()
        mod.uploadUrl = process.env.VUE_APP_UPLOADURL
        inputFiles.push(mod)
      }

      this.$store.commit('setActiveConversationDocumentUploaderFiles', inputFiles)
      this.$store.commit('setActiveConversationDocumentUploaderVisibility', true)
      this.$refs.documentFileSelector.value = ''
    },

    showContactInfo() {
      this.$store.state.display.rightSideColumn.isExpanded = true
      this.$store.state.display.rightSideColumn.visibleContent = 'contact'
    },

    showGroupInfo() {
      this.$store.state.display.rightSideColumn.isExpanded = true
      this.$store.state.display.rightSideColumn.visibleContent = this.$store.state.conversation.activeConversation.isChannelConversation ? 'channel' : 'group'
    }
  }
}
</script>

<style scoped>
.topActionBar {
  background-color: #eaeceb;
  height: 60px;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  border-bottom: rgb(223, 223, 223) 1px solid;
}

.avatarImageTopBar {
  background-color: white;
  border-radius: 50%;
  height: 45px;
  width: 45px;
  margin-left: 10px;
  cursor: pointer;
  margin-right: 10px;
  object-fit: cover;
  border: 1px solid #ffffff;
}

.searchBtn,
.attachBtn,
.menuBtn {
  width: 30px;
  height: 20px;
  cursor: pointer;
  margin-left: 15px;
}

.attachBtn {
  margin-top: 5px;
  margin-left: 10px;
}

.searchBtn > img,
.attachBtn > img,
.menuBtn > img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.spacer {
  flex-grow: 1;
  background-color: aliceblue;
}

.userName {
  height: 50%;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
}

.userInfo,
.userWriting {
  height: 50%;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: #999999;
  cursor: pointer;
}

.userWriting {
  font-style: italic;
}

.circleMenuImage {
  width: 25px;
  height: 25px;
  margin: 10px;
  margin-top: 12px;
}

.photoMenuItem {
  cursor: pointer;
  padding: 5px;
}

.photoMenuItem:hover {
  background-color: #ffbaf2;
}
</style>

<style>
.oy-menu-btn {
  line-height: 60px !important;
}

.oy-menu-item {
  margin-bottom: 50px;
}

.oy-menu-btn:focus {
  outline: 0;
}

.oy-menu-btn:active {
  background: none;
}

.menubtn {
  margin-bottom: 50px;
  cursor: pointer;
}
</style>
